import {FormControl, InputLabel, MenuItem, Select, SelectProps} from "@mui/material";

export interface SortOrderItem {
  value: string;
  label: string;
}

export interface SortOrderProps<T extends SortOrderItem[]> {
  value: T[number]['value'];
  onChange: SelectProps<T[number]['value']>['onChange'];
  items: T;
}

export default function SortOrder<T extends SortOrderItem[]>(props: SortOrderProps<T>) {
  return (
    <FormControl sx={{minWidth: 120}} size="small">
      <InputLabel id="sort-order-label">並び順</InputLabel>
      <Select
        labelId="sort-order-label"
        name="sortOrder"
        value={props.value}
        label="並び順"
        onChange={props.onChange}
        sx={{bgcolor: "white"}}
      >
        {props.items.map((item) => (
          <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
        )}
      </Select>
    </FormControl>
  )
}
